const initialState = {
    errorLogin: false,
    errorToken: false,
    errorPassword: false,
    responseLogin: false,
    errorLoginToken: false,
    status: '',
    responseUserLogin: [],
    responsePasswordReset: [],
    responsePasswordConfirm: [],
    responseError: [],
    responseLoginReintegro: false,
    responseDataLoginReintegro: {},
    responsePasswordChange: [],
    responseErrorChange: [],
    responseUserModules: [],
    responseErrorModules: [],
    messageToken: null
};

const reducer = (state = initialState, action) => {
    const newState = { ...state };

    switch (action.type) {
        case "USER_LOGIN_RESPONSE":
            if (action.value.detail !== undefined) { //si hubo error
                newState.responseError = action.value;
                newState.responseUserLogin = [];
            } else { //si NO hubo error
                newState.responseUserLogin = action.value;
                newState.responseError = [];
                let newUserData = JSON.stringify(action.value)
                window.localStorage.setItem('userData', newUserData);
                window.localStorage.setItem('headersSetCookie', action.access);

            }
            break;
        case "GET_LOGIN_RESPONSE":
            if (action.value.access !== undefined) {
                newState.headersSetCookie = action.value.access;
                newState.responseLogin = true;
                newState.errorLogin = false;
                window.localStorage.setItem('headersSetCookie', action.value.access);
            } else {
                const status_http = action.value?.status_http;
                if (status_http === undefined) {
                    newState.errorLogin = true;
                    newState.errorToken = false
                } else {
                    if (status_http === 403) {
                        newState.errorLogin = false;
                        newState.errorToken = true
                    } else {
                        newState.errorLogin = true;
                        newState.errorToken = false
                    }
                }
            }
            break;
        case "AUTHENTICATE_TOKEN_RESPONSE":
            if (action.value.access !== undefined) {
                newState.errorLoginToken = false;
                window.localStorage.setItem('headersSetCookie', action.value.access);
                newState.status = 'ok'
                newState.messageToken = null
            } else {
                const status_http = action.value?.status_http;
                if (status_http === 403) {
                    newState.errorLoginToken = true;
                    newState.messageToken = action.value?.detail
                    newState.status = 'ko'
                } else {
                    newState.errorLoginToken = false;
                    newState.status = 'ko'
                    newState.messageToken = null
                }
            }
            break;
        case "GET_LOGIN_REINTEGRO_RESPONSE":
            if (action.value.refunds !== undefined) {
                newState.headersSetCookie = action.value.access;
                newState.responseLoginReintegro = true;
                newState.errorLoginReintegro = false;
                newState.responseDataLoginReintegro = action.value;
                window.localStorage.setItem('headersSetCookie', action.value.access);
                newState.mensajeError = false;
            } else {
                newState.errorLoginReintegro = true;
                if (action.value.detail !== undefined) {
                    newState.mensajeError = action.value.detail;
                }
            }
            break;
        case "GET_LOGOUT":
            newState.responseLogin = false;
            newState.headersSetCookie = '';
            newState.errorToken = false;
            newState.status = false;
            newState.messageToken = null;
            window.localStorage.removeItem('headersSetCookie');
            window.localStorage.removeItem('userData');

            break;
        case "GET_LOGOUT_REINTEGRO":
            newState.responseLoginReintegro = false;
            sessionStorage.clear();
            window.localStorage.clear();
            newState.headersSetCookie = '';
            window.localStorage.removeItem('headersSetCookie');
            window.localStorage.removeItem('userData');
            break;
        case "PASSWORD_RESET_RESPONSE":
            if (action.value.detail !== undefined || action.value.email !== undefined) { //si hubo error
                newState.responsePasswordReset = [];
                newState.responseError = action.value;
                newState.errorPassword = true;
            } else { //si NO hubo error
                newState.responsePasswordReset = action.value;
                newState.responseError = [];
                newState.errorPassword = false;
            }
            break;
        case "PASSWORD_CHANGE_RESPONSE":
            if (action.value.code !== 200) { //si hubo error
                newState.responsePasswordChange = [];
                newState.responseErrorChange = action.value;
            } else { //si NO hubo error
                newState.responsePasswordChange = action.value;
                newState.responseErrorChange = [];
            }
            break;
        case "PASSWORD_CONFIRM_RESPONSE":
            if (action.value.detail !== undefined || action.value.password !== undefined) {
                newState.responsePasswordConfirm = [];
                newState.responseError = action.value;
                newState.errorPassword = true;
            } else { // no hubo errores
                newState.responsePasswordConfirm = action.value;
                newState.responseError = [];
                newState.errorPassword = false;
            }
            break;
        case "USER_MODULE_RESPONSE":
            if (action.value.detail !== undefined) { //si hubo error
                newState.responseUserModules = [];
                newState.responseErrorModules = action.value;
            } else { //si NO hubo error
                newState.responseUserModules = action.value;
                newState.responseErrorModules = [];
            }
            break;
        default:
            return newState;
    }

    return newState;
};

export default reducer;